import _ from 'lodash';
export const truncate = (value,maxLength)=>{
    if(!_.isEmpty(value) && value.length > maxLength){
        return value.slice(0,maxLength);
    }
    return value;
}